class Utils {

    static getMobileOS = () => {
        const ua = navigator.userAgent;
        // console.log(ua);
        if (/android/i.test(ua)) {
            return 'Android';
        } else if ((/iPad|iPhone|iPod/.test(ua)) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            return 'iOS';
        }
        return 'PC';
    };

    static isWebview = () => {
        const ua = navigator.userAgent;
        if (/mata-scratch/i.test(ua)) {
            return 'webview';
        }
    };

}

// module.exports = Utils;
export default Utils;